// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Y1PW5","content":"RecentSearches_content__WQrs5"};